<template>
  <div class="app-download-wrapper">
    <!-- 下载入口按钮 -->
    <div class="app-source-box">
      <div class="app-item" @click="openDialog('testflight')">
        <img src="@/assets/login/testflight.webp" title="TestFlight" />
      </div>
      <div class="app-item" @click="openDialog('android')">
        <img src="@/assets/login/android.webp" title="Android" />
      </div>
    </div>

    <!-- 二维码弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
      center
      @close="onClose"
    >
      <div class="qr-content">
        <div class="qr-code-box">
          <vueQr :text="currentQrText" :size="200" />
        </div>
        <div class="qr-link-box">
            <el-link target="_blank" :underline="false" type="primary" :href="currentQrText">{{ currentQrText }}</el-link>
        </div>
        <div class="qr-description">{{ currentDesc }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr'

const TESTFLIGHT_URL = 'https://testflight.apple.com/join/XzQJXkcy'
const ANDROID_URL = 'https://files.fotoncard.com/FotonCard.apk'

// const DESC_MAP = {
//   testflight: '為提供更完善功能，目前IOS系統僅支持通過TestFlight下載，請掃碼並按照指示安裝。\n\n特別提醒：請通過FotonCard官方渠道下載APP，從其他任何渠道獲得的應用程式均不可信！',
//   android: '為提供更完善功能，目前Android系統僅支持通過APK安裝，請放心掃碼安裝。\n\n特別提醒：請通過FotonCard官方渠道下載APK，從其他任何渠道獲得的應用程式均不可信！'
// }

export default {
  name: 'AppDownload',
  components: { vueQr },
  data() {
    return {
      dialogVisible: false,
      currentQrText: '',
      currentDesc: ''
    }
  },
  computed: {
    DESC_MAP() {
        let desc = {
            testflight: this.$t("AppDownload.TestFlightTip"),
            android: this.$t("AppDownload.AndroidTip")
        }

        return desc;
    }
  },
  methods: {
    openDialog(platform) {
      this.currentQrText = platform === 'testflight' ? TESTFLIGHT_URL : ANDROID_URL
      this.currentDesc = this.DESC_MAP[platform]
      this.dialogVisible = true
    },
    onClose() {
      this.currentQrText = ''
      this.currentDesc = ''
    }
  }
}
</script>

<style scoped>
.app-source-box {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding-bottom: 20px;
}

.app-item {
  height: 40px;
  cursor: pointer;
  /* flex: 1; */
}

.app-item img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

.qr-code-box {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.qr-description {
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  padding: 0 10px;
}

.qr-link-box {
    margin-bottom: 15px;
}
</style>